import React from 'react';
import { AddIcon } from '@commonsku/styles';

export default function AddButton({ label }) {
    return (
        <div style={{display: 'flex', alignItems: 'center'}}><AddIcon width="1rem"></AddIcon> <span>{label || 'Add New'}</span></div>
    );
}
